<template>
    <alert-validation-errors :errors="errorsList"></alert-validation-errors>
</template>

<script>
import AlertValidationErrors from './AlertValidationErrors'

export default {
  name: 'AlertValidationErrorsFromAJAX',
  props: {
    errors: {
      type: Object,
      required: true
    }
  },

  components: { AlertValidationErrors },
  computed: {
    errorsList () {
      return Object.values(this.errors).flat()
    }
  }
}
</script>
